import { useState, useCallback } from 'react';
export const useModal = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const handleModalOpen = useCallback(() => {
        setModalOpen(true);
    }, []);
    const handleModalClose = useCallback(() => {
        setModalOpen(false);
    }, []);
    return { modalOpen, handleModalOpen, handleModalClose };
};
//# sourceMappingURL=useModal.js.map